import React, { useLayoutEffect } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import ServicioAutenticidadContenidoSection from '../sections/ServicioAutenticidadContenido'
import Seo from '../components/Seo'
import { sizes } from '../utils/breakpoints'

const ServicioAutenticidadContenido = () => {
  const { t } = useTranslation()

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container>
      <Seo
        title={t('seo.c2pa.title')}
        description={t('seo.c2pa.description')}
        path="/servicios/autenticidad-contenido-digital"
        serviceName={t('seo.c2pa.title')}
      />
      <ServicioAutenticidadContenidoSection />
    </Container>
  )
}

export default ServicioAutenticidadContenido

const Container = styled.div`
  padding-top: 110px;

  @media (max-width: ${sizes.mobile}px) {
    padding-top: 70px;
  }
`
